import React, { useEffect, useState } from 'react';

export default function DealershipInventory() {
  const id = window.location.pathname.split('/')[2];
  const [dealership, setDealership] = useState(null);
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    fetch(`/api/dealerships/${id}`)
      .then(res => res.json())
      .then(setDealership);
    fetch(`/api/dealerships/${id}/vehicles`)
      .then(res => res.json())
      .then(setVehicles);
  }, [id]);

  if (!dealership) return <div>Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-8">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 break-words">{dealership.name} Inventory</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
        {vehicles.map(vehicle => (
          <div key={vehicle._id} className="bg-white rounded-xl shadow p-3 sm:p-4">
            <img
              src={vehicle.imageOne}
              alt={vehicle.model}
              className="w-full h-32 sm:h-40 object-cover rounded mb-2"
              onError={e => (e.target.style.display = 'none')}
            />
            <div className="font-bold text-sm sm:text-base break-words">{vehicle.year} {vehicle.make} {vehicle.model}</div>
            <div className="text-sm sm:text-base break-words">Stock #: {vehicle.stockNumber}</div>
            <div className="text-red-600 font-bold text-sm sm:text-base">${vehicle.price}</div>
            {/* Add more details as needed */}
          </div>
        ))}
      </div>
    </div>
  );
}
